import { CheckInDetail } from "../../models/checkInDetail";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckInStatusBadge } from "./checkInStatusBadge";
import { decode } from "html-entities";
import { useAtomValue } from "jotai";
import { isBackstageUserAtom, userAtom } from "../../atoms/userAtom";
import { BackstageHeader } from "./backstageHeader";
import { useEffect } from "react";

interface CheckInDetailHeaderProps {
  checkIn?: CheckInDetail | null;
  title: string;
}

export function CheckInDetailHeader({
  checkIn,
  title,
}: CheckInDetailHeaderProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isBackstageUser = useAtomValue(isBackstageUserAtom);
  useEffect(() => {}, [isBackstageUser]);

  return (
    <>
      {}
      <div className={"drop-shadow z-10"}>
        {isBackstageUser ? (
          <BackstageHeader title={title} />
        ) : (
          <div className="navbar bg-base-100 w-full ">
            <div className={"flex-none"}>
              <button
                className={"btn btn-ghost btn-square"}
                onClick={() =>
                  navigate(pathname.substring(0, pathname.lastIndexOf("/")))
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <div className={"text-xl"}>{title}</div>
          </div>
        )}
        <div className={"flex bg-base-200 items-center p-3 min-h-14"}>
          <div className={"flex-1 flex flex-col"}>
            <div
              className={
                "text-wrap text-md break-all whitespace-pre-line line-clamp-2"
              }
            >
              {decode(checkIn?.internalTitle)}
            </div>
            {checkIn?.rewardTitle && (
              <div
                className={"text-sm break-all whitespace-pre-line line-clamp-1"}
              >
                {`${checkIn.rewardTitle[checkIn.primaryLanguage]}`}
              </div>
            )}
          </div>
          <CheckInStatusBadge eventStatus={checkIn?.checkInStatus} />
        </div>
      </div>
    </>
  );
}
